// extracted by mini-css-extract-plugin
export default {"nav":"NavbarWide_nav__7WIOc","logo":"NavbarWide_logo__moSGQ","items":"NavbarWide_items__kIeug","borderActive":"NavbarWide_borderActive__V0xc7"};